/**
 * install 子命令：在使用者自己的项目里生成 Claude / Cursor 客户端文件，
 * 或（可选）把 codebuddy/workbuddy 挂到用户级目录。
 *
 * 与 postinstall 的区别：postinstall 自动只挂用户级 codebuddy/workbuddy（包根即 skillRoot）；
 * 本命令面向"已 npm 安装、但想在本地项目里用 Cursor/Claude"的使用者，--project-root 指向其项目。
 */
import { Command } from "commander";
import * as path from "node:path";
import { fileURLToPath } from "node:url";
import { runInstall, expandClients, KNOWN_CLIENTS, type Client } from "../install-skill.js";

export function registerInstall(program: Command) {
  program
    .command("install")
    .description("装载 BaskReport skill 到 AI 客户端（生成 .claude/.cursor 文件或挂用户级目录）。")
    .option(
      "--clients <list>",
      `逗号分隔的客户端列表，支持: ${KNOWN_CLIENTS.join(", ")} 或 all`,
      "all",
    )
    .option("--project-root <dir>", "项目级文件（claude/cursor）的生成目录；缺省为当前目录")
    .option("--build", "装载前先执行 npm install && npm run build")
    .action((opts: { clients: string; projectRoot?: string; build?: boolean }) => {
      const clients = expandClients(
        opts.clients.split(",").map((c) => c.trim()).filter(Boolean),
      ) as Client[];
      const projectRoot = opts.projectRoot ?? process.cwd();
      runInstall(
        { clients, build: Boolean(opts.build), projectRoot },
        // CLI 运行于包内 dist/cli/，skillRoot 用包根（dist 的上一级）
        path.resolve(path.dirname(fileURLToPath(import.meta.url)), "..", ".."),
      );
    });
}
